<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-recharge"
    title=""
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
    :show-close="false"
  >
    <template slot="title">
      <div>充值</div>
      <img
        class="icon-delete"
        src="@/assets/icon_dialog_delete.png"
        @click="handleCloseDialog"
      />
    </template>
    <div class="recharge-box">
      <div class="recharge-left-box">
        <div class="recharge-left-inner">
          <div class="plans-box">
            <div class="left-red-title">
              <div class="left-inner">
                <div class="border-left"></div>
                <div class="title-text">选择方案</div>
              </div>
            </div>
            <div class="plan-items-box">
              <div
                v-for="(item, idx) in productList"
                :key="idx"
                :class="[
                  'plan-item-box',
                  selectProductIdx === idx ? 'selected' : '',
                ]"
                @click="handleSelectProduct(idx, item)"
              >
                <div class="usetime-box">{{ item.month }}个月</div>
                <div class="price-box">
                  <span class="symbol-money">¥</span
                  ><span>{{ item.price }}</span>
                </div>
                <div v-if="item.originPrice" class="originprice-box">
                  ¥{{ item.originPrice }}
                </div>
                <img
                  class="img-selected"
                  src="@/assets/icon_selected_red3.png"
                />
              </div>
            </div>
          </div>
          <!--<div class="coupons-box">
            <div class="left-red-title">
              <div class="left-inner">
                <div class="border-left"></div>
                <div class="title-text">选择优惠券</div>
                <el-tooltip
                  placement="bottom-end"
                  popper-class="coupon-tooltip-box"
                  :enterable="true"
                >
                  <div slot="content" class="coupon-tooltip">
                    <div class="tip-item">
                      新人一折优惠券：购买12个月会员方<br />可使用新人一折优惠券，此券不可与<br />其他优惠同享；
                    </div>
                    <div class="tip-item">
                      项目发布抵扣券：发布项目专用券，<br />即发布项目时，方可使用此券。
                    </div>
                  </div>
                  <div class="right-inner">
                    <img
                      class="icon-remind"
                      src="@/assets/icon_remind_red.png"
                    />
                    <span>使用说明</span>
                  </div>
                </el-tooltip>
                <div class="title-desc">
                  <template v-if="couponList.length > 0">
                    <template>{{ showUseCouponTip }}</template>
                    &lt;!&ndash; <template v-if="couponList[0].status === 0">{{showCouponTip}}</template> &ndash;&gt;
                    &lt;!&ndash; &&selectProductIdx!==3 &ndash;&gt;
                    &lt;!&ndash; <template v-if="couponList[0].status === 1"></template> &ndash;&gt;
                  </template>
                </div>
              </div>
            </div>
            <div v-if="couponList.length <= 0" class="nocoupon-box">
              <img class="img-discount" src="@/assets/icon_discount.png" />
              <div class="nocoupon-tip">暂无优惠券</div>
            </div>
            <div class="hadcoupon-box" v-else>
              <div v-if="selectCoupon !== null" class="usecoupon-tip">
                <span>你已使用优惠券1张，优惠金额</span>
                <span class="money">¥{{ showCouponMoney | numFilter }}</span>
              </div>
              <div
                v-if="couponList.length > 0"
                :class="[
                  'coupons-item-box',
                  selectCoupon !== null ? 'usecoupon' : '',
                ]"
              >
                <template v-for="(item, idx) in couponList">
                  &lt;!&ndash; item.status === 2 ? 'timeout' : '' &ndash;&gt;
                  <div
                    :key="idx"
                    :class="[
                      'small-coupon-item-box',
                      couponIsDisabled ? 'timeout' : '',
                      selectCouponIndex === idx ? 'selectedCoupon' : '',
                    ]"
                  >
                    <div class="coupon-item-top">
                      <div class="top-inner">
                        <div class="name-btn-box">
                          <div
                            class="symbol-money-box"
                            v-if="item.type_rule_4_score == 202"
                          >
                            ¥
                          </div>
                          <div
                            :class="[
                              'name-cont',
                              item.type_rule_4_score == 104
                                ? 'name-money-cont'
                                : '',
                            ]"
                          >
                            新人1折优惠券
                            <div
                              v-if="item.type_rule_4_score == 202"
                              class="name-desc-cont"
                            >
                              {{ item.nameDesc }}
                            </div>
                          </div>
                          <el-button
                            v-if="item.coupon_status === 0"
                            class="custom-button btn-getcoupon btn-getnow"
                            @click.stop="handleGetCouponNow(item)"
                            >立即领取
                          </el-button>
                          <div
                            v-if="item.coupon_status === 102"
                            :class="[
                              'selected-box',
                              selectCouponIndex === idx ? 'selected' : '',
                            ]"
                            @click.stop="handleSelectCoupon(item, idx)"
                          ></div>
                          <div
                            v-if="item.coupon_status === 103"
                            :class="['selected-box']"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="split-radius-line-box">
                      <div class="left-box"></div>
                      <div class="split-line"></div>
                      <div class="right-box"></div>
                    </div>
                    <div class="coupon-item-bottom">
                      <div
                        :class="[
                          'coupon-rules-box',
                          item.isExpand ? 'expand-rule' : '',
                        ]"
                      >
                        <div
                          v-for="(itemRule, idxRule) in item.rules"
                          :key="idxRule"
                          class="coupon-rule-item"
                        >
                          {{ itemRule }}
                        </div>
                      </div>
                      <div
                        :class="['icon-expand', item.isExpand ? 'expand' : '']"
                        @click="handleExpand(item)"
                      ></div>
                    </div>
                    &lt;!&ndash; <div class="mask"></div> &ndash;&gt;
                  </div>
                </template>
              </div>
            </div>
          </div>-->
          <div class="paytype-box">
            <div class="left-red-title">
              <div class="left-inner">
                <div class="border-left"></div>
                <div class="title-text">选择支付方式</div>
              </div>
            </div>
            <div class="paytype-items-box">
              <div class="paytype-item-box">
                <div
                  :class="[
                    'icon-check-paytype',
                    selectPayTypes.indexOf(0) !== -1 ? 'checked' : '',
                  ]"
                  @click="handleSelectPayType(0)"
                ></div>
                <img class="icon-paytype" src="@/assets/icon_pay_balance.png" />
                <div class="lable-paytype">余额支付</div>
                <div class="balance-box">
                  （可用余额<span class="cont-balance">¥{{ accountMoney }}</span
                  >）
                </div>
              </div>
              <div class="paytype-item-box">
                <div
                  :class="[
                    'icon-check-paytype',
                    selectPayTypes.indexOf(1) !== -1 ? 'checked' : '',
                  ]"
                  @click="handleSelectPayType(1)"
                ></div>
                <img class="icon-paytype" src="@/assets/icon_pay_wechat.png" />
                <div class="lable-paytype">微信支付</div>
              </div>
              <div class="paytype-item-box">
                <div
                  :class="[
                    'icon-check-paytype',
                    selectPayTypes.indexOf(2) !== -1 ? 'checked' : '',
                  ]"
                  @click="handleSelectPayType(2)"
                ></div>
                <img class="icon-paytype" src="@/assets/icon_pay_ali.png" />
                <div class="lable-paytype">支付宝支付</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="recharge-right-box">
        <div class="icon-name-time-box">
          <img class="icon-img" src="@/assets/icon_vip_red.png" />
          <div class="name-time-box">
            <div class="name">
              专业版-{{ selectProduct ? selectProduct.month : "1" }}个月
            </div>
            <div class="time-box">
              <div>会员到期时间：</div>
              <div>{{ selectProduct ? selectProduct.timeTo : timeToEnd }}</div>
            </div>
          </div>
        </div>
        <div class="orderinfo-box">
          <div class="orderinfo-item-box">
            <div class="label">订单总额</div>
            <div class="item-cont">¥{{ productPrice.toFixed(2) }}</div>
          </div>
          <div class="orderinfo-item-box">
            <div class="label">优惠券</div>
            <div class="item-cont colEC4040">
              -¥{{ showCouponMoney.toFixed(2) }}
            </div>
          </div>
          <div class="orderinfo-item-box">
            <div class="label">余额支付</div>
            <div class="item-cont colEC4040">
              -¥{{ showUseAccountMoney.toFixed(2) }}
            </div>
          </div>
        </div>
        <div class="order-pay-box">
          <template v-if="showPayType != -1 && showPayNowButton">
            <div class="balancepay-money-box">
              <div class="label">应付金额</div>
              <div class="pay-money">¥{{ needPayMoney.toFixed(2) }}</div>
            </div>
            <el-button
              class="custom-button btn-ff3333 btn-balancepay"
              @click="handlePay"
              >立即支付</el-button
            >
          </template>
          <template v-if="showQrCodePay">
            <div class="qrcodepay-box">
              <img class="img-qrcode" :src="payQrCode" alt="qrcode" />
              <!-- <div class="img-qrcode" v-if="showPayType===2" v-html="alipayHtml"></div> -->
              <div class="money-tip-box">
                <div class="money-box">
                  <div class="label">应付金额</div>
                  <div class="pay-money">¥{{ needPayMoney.toFixed(2) }}</div>
                </div>
                <div class="tip-box">扫一扫支付</div>
              </div>
            </div>
          </template>
          <!-- <template v-if="showPayType === 0">
            <div class="balancepay-money-box">
              <div class="label">应付金额</div>
              <div class="pay-money">¥{{ needPayMoney.toFixed(2) }}</div>
            </div>
            <el-button class="custom-button btn-ff3333 btn-balancepay" @click="handlePay">立即支付</el-button>
          </template>
          <template v-if="showPayType === 1 || showPayType === 2">
            <div class="qrcodepay-box">
              <img v-if="showPayType===1" class="img-qrcode" :src="payQrCode" alt="qrcode" />
              <div class="img-qrcode" v-if="showPayType===2" v-html="alipayHtml"></div>
              <div class="money-tip-box">
                <div class="money-box">
                  <div class="label">应付金额</div>
                  <div class="pay-money">¥{{ needPayMoney.toFixed(2) }}</div>
                </div>
                <div class="tip-box">扫一扫支付</div>
              </div>
            </div>
          </template> -->
        </div>
      </div>
    </div>
    <CompCouponQrcode ref="compCouponQrcode"></CompCouponQrcode>
    <DialogConfirmPay
      ref="dialogConfirmPay"
      @cancel="confirmCancelPay"
      @sure="confirmSurePay"
    ></DialogConfirmPay>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import accountApi from "@/api/account";
import pageCommon from "@/utils/pagecommon";

import goodsApi from "@/api/goods";
import couponApi from "@/api/coupon";
import mywalletApi from "@/api/myWallet";
import CompCouponQrcode from "@/components/dialog/GetCouponQrcode";
import DialogConfirmPay from "@/components/dialog/ConfirmPay";
export default {
  name: "Recharge",
  components: {
    CompCouponQrcode,
    DialogConfirmPay,
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
  },
  data() {
    return {
      showDialog: false,
      productList: [
        {
          id: "1",
          month: 1,
          price: 299,
          originPrice: 0,
          append_order_remark_012: 1,
        },
        {
          id: "2",
          month: 3,
          price: 807,
          originPrice: 897,
          append_order_remark_012: 0.9,
        },
        {
          id: "3",
          month: 6,
          price: 1435,
          originPrice: 1794,
          append_order_remark_012: 0.8,
        },
        {
          id: "4",
          month: 12,
          price: 3588,
          originPrice: 1794,
          append_order_remark_012: 0.5,
        },
      ],
      selectProductIdx: null,
      selectProduct: null,
      couponList: [],
      couponData: [],
      selectCouponIndex: null,
      selectCoupon: null,
      payType: null,
      selectPayTypes: [],
      payQrCode: "",
      alipayHtml: "",
      isRequesting: false,
      paying: false,
      showPayNowButton: true,
      showQrCodePay: false,
      timeInterval: null,
      timeToEnd: null,
      userBalance: null,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let userInfo = _this.$store.state.user;
      return userInfo;
    },
    accountMoney: function () {
      let _this = this;
      if (_this.userBalance) {
        return _this.userBalance.cust_stat_left_money_num;
      }
      return 0;
    },
    couponIsDisabled: function () {
      let _this = this;
      if (_this.couponList.length > 0) {
        let item = _this.couponList[0];
        console.log(item);
        if (item.coupon_status == 103) {
          return true;
        }
        if (item.coupon_status == 102) {
          return _this.selectProductIdx !== 3;
        }
      }
    },
    productPrice: function () {
      let _this = this;
      if (_this.selectProduct) {
        if (_this.selectCoupon) {
          return parseFloat(_this.selectProduct.price) * 2;
        } else {
          return parseFloat(_this.selectProduct.price);
        }
      }
      return 0;
    },
    showCouponMoney: function () {
      let _this = this;
      if (_this.selectCoupon) {
        let couponMoney = 0;
        let discount = 0;
        // isDiscount以折扣计算
        if (_this.selectCoupon.isDiscount === 1) {
          console.log(_this.productPrice);
          console.log(_this.selectCoupon.discount);
          console.log(_this.couponData);
          if (
            _this.selectCoupon.append_inner_key ==
            _this.couponData[0].id_public_rule_4_score
          ) {
            discount = this.couponData[0].rule_4_score_remark_005;
          }
          couponMoney = (_this.productPrice * 100 * (0.9 * 100)) / 10000;
        }
        console.log(couponMoney);
        if (_this.selectCoupon.isDiscount === 0) {
          // couponMoney =
          //   _this.productPrice - parseFloat(_this.selectCoupon.discountMoney);
          if (
            _this.productPrice <= parseFloat(_this.selectCoupon.discountMoney)
          ) {
            return _this.productPrice;
          }
          if (
            _this.productPrice > parseFloat(_this.selectCoupon.discountMoney)
          ) {
            return _this.selectCoupon.discountMoney;
          }
        }
        if (couponMoney <= 0) {
          return _this.productPrice;
        }
        return couponMoney;
      }
      return 0;
    },
    showUseAccountMoney: function () {
      let _this = this;
      if (_this.selectPayTypes.indexOf(0) !== -1 && _this.accountMoney > 0) {
        if (_this.selectProduct) {
          if (_this.productPrice <= _this.showCouponMoney) {
            return 0;
          } else {
            let payMoney = _this.productPrice - _this.showCouponMoney;
            if (_this.accountMoney >= payMoney) {
              return payMoney;
            } else {
              return parseFloat(_this.accountMoney);
            }
          }
        }
        return 0;
      } else {
        return 0;
      }
    },
    needPayMoney: function () {
      let _this = this;
      if (_this.selectProduct) {
        let otherMoney =
          _this.productPrice -
          _this.showCouponMoney -
          _this.showUseAccountMoney;
        return otherMoney;
      }
      return 0;
    },
    showPayType: function () {
      let _this = this;
      if (!_this.selectProduct) {
        return -1;
      }
      if (_this.selectPayTypes.length) {
        if (_this.needPayMoney <= 0) {
          return 0;
        }
        if (_this.selectPayTypes.indexOf(0) !== -1) {
          if (_this.selectPayTypes.indexOf(1) !== -1) {
            return 1;
          }
          if (_this.selectPayTypes.indexOf(2) !== -1) {
            return 2;
          }
          return 0;
        }
        if (_this.selectPayTypes.indexOf(1) !== -1) {
          return 1;
        }
        if (_this.selectPayTypes.indexOf(2) !== -1) {
          return 2;
        }
      }
      return -1;
    },
    userShopInfo: function () {
      let _this = this;
      let userShopInfo = _this.$store.state.userShopInfo;
      return userShopInfo;
    },
    showUseCouponTip: function () {
      let _this = this;
      if (_this.couponList.length && _this.couponList[0]) {
        if (_this.couponList[0].coupon_status == 0) {
          return "（只需邀请一个好友注册，即可解锁新人一折优惠券）";
        }
        if (_this.couponList[0].coupon_status == 1) {
          return "（购买12个月会员方可使用新人一折优惠券，此券不可叠加使用）";
        }
      }
      return "";
    },
    ways_of_payment: function () {
      let _this = this;
      console.log(_this.selectPayTypes, "xxxxxxxxxxxxx");
      if (_this.selectPayTypes.length <= 0) {
        return -1;
      }
      if (_this.selectCoupon) {
        // 使用优惠券时:
        // 余额支付: 2112
        // 微信支付:  4112
        // 支付宝支付: 3112
        // 余额+微信支付: 4212
        // 余额+支付宝支付:  3212
        if (_this.selectPayTypes.length === 1) {
          if (_this.selectPayTypes[0] === 0) {
            //余额支付
            return 1212;
          }
          if (_this.selectPayTypes[0] === 1) {
            //微信支付
            return 4112;
          }
          if (_this.selectPayTypes[0] === 2) {
            //支付宝支付
            return 3112;
          }
        } else if (_this.selectPayTypes.length === 2) {
          if (_this.selectPayTypes.indexOf(1) !== -1) {
            //余额+微信支付
            return 4212;
          } else if (_this.selectPayTypes.indexOf(2) !== -1) {
            //余额+支付宝支付
            return 3212;
          }
        }
      } else {
        //         不使用优惠券时:
        // 余额支付: 2111
        // 微信支付:  4111
        // 支付宝支付: 3111
        // 余额+微信支付: 4211
        // 余额+支付宝支付:  3211
        if (_this.selectPayTypes.length === 1) {
          if (_this.selectPayTypes[0] === 0) {
            //余额支付
            return 1211;
          }
          if (_this.selectPayTypes[0] === 1) {
            //微信支付
            return 4111;
          }
          if (_this.selectPayTypes[0] === 2) {
            //支付宝支付
            return 3111;
          }
        } else if (_this.selectPayTypes.length === 2) {
          if (_this.selectPayTypes.indexOf(1) !== -1) {
            //余额+微信支付
            return 4211;
          } else if (_this.selectPayTypes.indexOf(2) !== -1) {
            //余额+支付宝支付
            return 3211;
          }
        }
      }
    },
  },
  created() {},
  methods: {
    handleShow: function () {
      let _this = this;
      let nowDate;
      if (_this.userInfo.user_remark_012 === "1202") {
        nowDate = _this.userInfo.user_remark_013.split(" ")[0];
      } else {
        nowDate = _this.$moment(new Date()).format("YYYY-MM-DD");
      }

      _this.showDialog = true;
      _this.paying = false;
      _this.selectProductIdx = 0;
      _this.selectProduct = _this.productList[0];
      _this.selectProduct.timeTo = _this.GetNextMonthDay(nowDate, 1);
      _this.selectPayTypes = [];
      _this.couponList = [];
      _this.showPayNowButton = true;
      _this.showQrCodePay = false;
      _this.getGoodsInfo();
    },
    getGoodsInfo: function () {
      let _this = this;
      let requestData = {
        isloading: true,
      };
      pageCommon.apiRequestCommon(goodsApi, "showGoodsInfo", requestData).then(
        (res) => {
          if (
            res &&
            res.public_goods_list &&
            res.public_goods_list.length > 0
          ) {
            let goodsInfo = res.public_goods_list[0];
            //3个月打9折，6个月打8折，12个月5折
            let price =
              goodsInfo.publicGoodsSupply4Shop.new_price_4_shop_retail;
            for (let i = 0; i < _this.productList.length; i++) {
              const element = _this.productList[i];
              let originPrice = element.month * parseFloat(price);
              if (element.month == 1) {
                element.price = originPrice.toFixed(2);
                element.originPrice = 0;
              } else if (element.month == 3) {
                element.price = (originPrice * 0.9).toFixed(2);
                element.originPrice = originPrice.toFixed(2);
              } else if (element.month == 6) {
                element.price = (originPrice * 0.8).toFixed(2);
                element.originPrice = originPrice.toFixed(2);
              } else if (element.month == 12) {
                element.price = (originPrice * 0.5).toFixed(2);
                element.originPrice = originPrice.toFixed(2);
              }
            }
            _this.getAccountAndCoupon();
            _this.getWalletBase();
          } else {
            _this.showDialog = false;
          }
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
          _this.showDialog = false;
        }
      );
    },
    getCouponData: function () {
      let requestData = {
        type_rule_4_score: 104,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(couponApi, "getCoupons", requestData)
        .then((response) => {
          console.log(response);
          if (response.public_score_list.length) {
            this.couponData = response.public_score_list;
          }
        });
    },
    getAccountAndCoupon: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        limit: 1000,
        id_public_user_info: _this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(couponApi, "getUserGetCoupons", requestData)
        .then(
          (res) => {
            let userCouponList =
              res && res.public_score_list ? res.public_score_list : [];
            let couponList = [];
            console.log(res)
            for (let i = 0; i < userCouponList.length; i++) {
              const element = userCouponList[i];
              if (element.score_type == 104) {
                let coupon_status = 102; //未使用
                if (element.is_online == 1) {
                  coupon_status = 103; //已使用
                }
                element.coupon_status = coupon_status;
                console.log(element);
                element.isExpand = false;
                if (element.rule_4_score_remark_004) {
                  element.rules = element.rule_4_score_remark_004.split("\n");
                } else {
                  element.rules = ['416'];
                }
                element.isDiscount = 1;
                element.discount = element.rule_4_score_remark_005;
                couponList.push(element);
              }
            }
            console.log(couponList);
            if (couponList.length) {
              _this.couponList = couponList;
              _this.getCouponData();
            } else {
              _this.getWaitCouponList();
            }
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
            _this.showDialog = false;
          }
        );
    },
    getWaitCouponList: function () {
      let _this = this;
      let requestData = {
        type_rule_4_score: 104,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(couponApi, "getWaitCoupons", requestData)
        .then(
          (res) => {
            console.log(res)
            let userCouponList =
              res && res.public_score_list ? res.public_score_list : [];
            userCouponList.forEach((element) => {
              let coupon_status = 0; //待领取
              element.coupon_status = coupon_status;
              element.isExpand = false;
              console.log("ces:"+element.rule_4_score_remark_004)
              if (element.rule_4_score_remark_004) {
                element.rules = element.rule_4_score_remark_004.split("\n");
              } else {
                element.rules = [];
              }
              element.isDiscount = 1;
              element.discount = element.rule_4_score_remark_005;
            });
            _this.couponList = userCouponList;

            console.log(_this.couponList);
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
            _this.showDialog = false;
          }
        );
    },
    // 选择产品
    handleSelectProduct: function (val, item) {
      let _this = this;
      if (_this.paying) {
        return;
      }
      if (val === _this.selectProductIdx) {
        return;
      } else {
        let nowDate;
        if (_this.userInfo.user_remark_012 === "1202") {
          nowDate = _this.userInfo.user_remark_013.split(" ")[0];
        } else {
          nowDate = _this.$moment(new Date()).format("YYYY-MM-DD");
        }
        _this.selectProductIdx = val;
        _this.selectProduct = item;

        _this.selectProduct.timeTo = _this.GetNextMonthDay(
          nowDate,
          _this.selectProduct.month
        );
        console.log(_this.selectProduct);

        if (_this.selectProductIdx !== 3) {
          _this.selectCouponIndex = null;
          _this.selectCoupon = null;
        }
      }
    },

    GetNextMonthDay(date, monthNum) {
      var dateArr = date.split("-");
      var year = dateArr[0]; //获取当前日期的年份
      var month = dateArr[1]; //获取当前日期的月份
      var day = dateArr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + parseInt(monthNum);
      if (month2 > 12) {
        year2 =
          parseInt(year2) +
          parseInt(parseInt(month2) / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = parseInt(month2) % 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }

      var t2 = year2 + "年" + month2 + "月" + day2 + "日";
      return t2;
    },

    // 领取用户券
    handleGetCouponNow: function (item) {
      let _this = this;
      item.status = 1;
      _this.$refs.compCouponQrcode.showDialog = true;
      // item.isGet = true;
    },
    // 使用用户券
    handleSelectCoupon: function (item, idx) {
      let _this = this;
      if (_this.paying) {
        return;
      }
      if (_this.couponIsDisabled) {
        return;
      }
      if (idx === _this.selectCouponIndex) {
        _this.selectCouponIndex = null;
        _this.selectCoupon = null;
      } else {
        _this.selectCouponIndex = idx;
        _this.selectCoupon = item;
      }
    },
    // 展开优惠券描述
    handleExpand: function (item) {
      let _this = this;
      item.isExpand = !item.isExpand;
    },

    handlePay: function () {
      let _this = this;
      if (_this.paying) {
        return;
      }
      _this.paying = true;
      if (_this.ways_of_payment == 1212 || _this.ways_of_payment == 1211) {
        if (Number(_this.accountMoney) === 0) {
          _this.$message.warning("余额不足");
          _this.paying = false;
          return;
        } else {
          _this.$refs.dialogConfirmPay.showDialog = true;
        }
      } else {
        _this.numChangeMain();
      }
    },
    confirmCancelPay: function () {
      let _this = this;
      _this.paying = false;
    },
    confirmSurePay: function () {
      let _this = this;
      console.log(_this.ways_of_payment);
      if (_this.ways_of_payment == -1) {
        _this.paying = false;
        return;
      }
      _this.numChangeMain();
    },
    numChangeMain: function () {
      let _this = this;
      let month = _this.selectProduct.month;
      let requestData = {
        id_public_goods_order_record:
          _this.userShopInfo.public_goods_order_record
            .id_public_goods_order_record,
        order_detail_change_data: `${687}-_-${month}`,
        opt_type: 0,
        seller_id: 300098,
        isloading: true,
      };
      pageCommon.apiRequestCommon(goodsApi, "numChange", requestData).then(
        (res) => {
          _this.preSubmitMain();
        },
        (err) => {
          _this.paying = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    preSubmitMain: function () {
      let _this = this;
      let ways_of_payment = _this.ways_of_payment;
      let requestData = {
        id_public_goods_order_record:
          _this.userShopInfo.public_goods_order_record
            .id_public_goods_order_record,
        ways_of_payment: ways_of_payment,
        phone_user: _this.userInfo.user_phone,
        receive_name: _this.userInfo.nick_name,
        type_order_4_application: 200002,
        id_public_score_record: _this.selectCoupon
          ? _this.selectCoupon.id_public_score_record
          : "",
        // ship_state: 1,
        append_order_remark_012: _this.selectProduct.append_order_remark_012,
        isloading: true,
      };
      console.log(requestData);
      pageCommon.apiRequestCommon(goodsApi, "preSubmit", requestData).then(
        (res) => {
          //单余额支付
          if (_this.ways_of_payment == 1212 || _this.ways_of_payment == 1211) {
            _this.handleBalancePay();
          }
          // 包含微信支付
          if (
            _this.ways_of_payment == 4112 ||
            _this.ways_of_payment == 4212 ||
            _this.ways_of_payment == 4111 ||
            _this.ways_of_payment == 4211
          ) {
            _this.handleWechatPay();
          }
          // 包含支付宝支付
          if (
            _this.ways_of_payment == 3112 ||
            _this.ways_of_payment == 3212 ||
            _this.ways_of_payment == 3111 ||
            _this.ways_of_payment == 3211
          ) {
            _this.handleAliPay();
          }
        },
        (err) => {
          _this.paying = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    handleBalancePay: function () {
      let _this = this;
      let requestData = {
        id_public_goods_order_record:
          _this.userShopInfo.public_goods_order_record
            .id_public_goods_order_record,
      };
      pageCommon.apiRequestCommon(goodsApi, "balancePay", requestData).then(
        (res) => {
          _this.paying = false;
          _this.paySuccess();
        },
        (err) => {
          _this.paying = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    handleWechatPay: function () {
      let _this = this;
      let requestData = {
        id_public_goods_order_record:
          _this.userShopInfo.public_goods_order_record
            .id_public_goods_order_record,
        isloading: true,
      };
      pageCommon.apiRequestCommon(goodsApi, "wechatPay", requestData).then(
        (res) => {
          // console.log(res,"getwechatpay")
          // let native_url = res.weixin_qr_url;
          // let equal_code = res.weixin_qr_code_equal;
          // let and_code = res.weixin_qr_code_and;
          // native_url = native_url.replace(new RegExp(equal_code, 'g'), '=');
          // native_url = native_url.replace(new RegExp(and_code, 'g'), '&');
          // native_url = native_url.replace(new RegExp('&', 'g'), '%26');
          // _this.payQrCode = 'https://app001.downline.cn/mgr_image_code.png?invoke_method=public_page_4m_qr_img&qr_size=300&bar_img_content='+native_url
          // _this.showPayNowButton=false;
          // _this.showQrCodePay=true;
          let native_url = res.weixin_qr_url;
          let equal_code = res.weixin_qr_code_equal;
          let and_code = res.weixin_qr_code_and;
          native_url = native_url.replace(new RegExp(equal_code, "g"), "=");
          native_url = native_url.replace(new RegExp(and_code, "g"), "&");
          native_url = native_url.replace(new RegExp("&", "g"), "%26");
          _this.payQrCode =
            "http://www.duzikai.com/duzikai_api_mgr_image_code.png?invoke_method=public_page_4m_qr_img&qr_size=300&bar_img_content=" +
            native_url;
          _this.showPayNowButton = false;
          _this.showQrCodePay = true;
          _this.timeInterval = setInterval(() => {
            _this.handleSearchSate();
          }, 2000);
        },
        (err) => {
          _this.paying = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
          _this.showDialog = false;
        }
      );
    },
    handleAliPay: function () {
      let _this = this;
      let requestData = {
        id_public_goods_order_record:
          _this.userShopInfo.public_goods_order_record
            .id_public_goods_order_record,
        isloading: true,
      };
      pageCommon.apiRequestCommon(goodsApi, "aliPay", requestData).then(
        (res) => {
          _this.paying = false;
          _this.handleGetUserInfo().then(() => {
            // _this.alipayHtml=res;
            let url = res.requestText;
            document.write(url);
          });
        },
        (err) => {
          _this.paying = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
          _this.showDialog = false;
        }
      );
    },
    paySuccess: function (res) {
      let _this = this;
      _this.handleGetUserInfo().then(() => {
        _this.$message.success("支付成功");
        _this.showDialog = false;
      });
    },
    handleSelectPayType: function (paytype) {
      let _this = this;
      console.log(_this.accountMoney);
      if (_this.paying) {
        return;
      }
      let idx = _this.selectPayTypes.indexOf(paytype);
      console.log(idx);
      if (idx !== -1) {
        _this.selectPayTypes.splice(idx, 1);
        //取消
      } else {
        let wpayIdx = _this.selectPayTypes.indexOf(1);
        let alipayIdx = _this.selectPayTypes.indexOf(2);
        if (paytype === 1 && alipayIdx !== -1) {
          _this.selectPayTypes.splice(alipayIdx, 1);
        }
        if (paytype === 2 && wpayIdx !== -1) {
          _this.selectPayTypes.splice(wpayIdx, 1);
        }
        // if(paytype===1){
        //   // 微信支付
        //   _this.getWechatPayImg();
        // }
        // else if(paytype===2){
        //   _this.getAliPayImg();
        // }
        _this.selectPayTypes.push(paytype);
      }
    },

    handleSearchSate() {
      let _this = this;
      let requestData = {
        id_public_goods_order_record:
          _this.userShopInfo.public_goods_order_record
            .id_public_goods_order_record,
      };
      pageCommon.apiRequestCommon(goodsApi, "searchState", requestData).then(
        (res) => {
          console.log(res);
          if (res.public_goods_order_record.ship_state === 1) {
            clearInterval(_this.timeInterval);
            _this.paying = false;
            _this.paySuccess();
          }
        },
        (err) => {
          _this.paying = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
          _this.showDialog = false;
        }
      );
    },

    handleCloseDialog: function () {
      let _this = this;
      clearInterval(_this.timeInterval);
      _this.showDialog = false;
    },
    handleGetUserInfo: function () {
      let _this = this;
      return new Promise((resolve, reject) => {
        pageCommon
          .apiRequestCommon(accountApi, "getUserShopInfo", {
            isloading: true,
          })
          .then(
            (res) => {
              console.log(res);
              _this.$store.dispatch("acUserShopInfo", res);
              _this.$store.dispatch("acUser", res.public_user_info);
              storage.set("usershop", JSON.stringify(res));
              resolve();
            },
            (err) => {
              if (err.sysUserLoginError) {
                _this.$message.error("系统异常，请稍后刷新重试！");
              } else {
                _this.$message.error(err.data.msg);
              }
              resolve();
            }
          );
      });
    },
    getWalletBase: function () {
      let _this = this;
      return new Promise((resolve, reject) => {
        if (_this.userInfo && _this.userInfo.id_public_user_info) {
          let requestData = {
            begin_idx: 0,
            limit: 1000,
            id_public_user_info: _this.userInfo.id_public_user_info,
            isloading: true,
          };
          pageCommon
            .apiRequestCommon(mywalletApi, "getWithDrawalMoney", requestData)
            .then(
              (res) => {
                _this.userBalance = res;
                resolve();
              },
              (err) => {
                _this.isRequesting = false;
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.$message.error(err.data.msg);
                }
                reject();
              }
            );
        } else {
          reject();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.dialog-recharge {
  /deep/.left-red-title {
    .border-left {
      height: 18px;
    }

    .title-text {
      font-size: 18px;
      line-height: 18px;
    }

    .title-desc {
      font-size: 14px;
      line-height: 14px;
      margin-left: 8px;
    }
  }

  /deep/.el-dialog {
    position: absolute;
    width: 1090px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;

    .el-dialog__header {
      position: relative;
      width: 1090px;
      height: 56px;
      background: #fff1f1;
      border-radius: 4px 4px 0px 0px;
      padding: 0;
      padding-left: 32px;
      padding-right: 32px;
      box-sizing: border-box;
      text-align: left;
      overflow: hidden;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #222222;
      line-height: 20px;

      .icon-delete {
        position: relative;
        width: 15.6px;
        height: 15.6px;
        cursor: pointer;
      }
    }

    .el-dialog__body {
      position: relative;
      width: 100%;
      height: 578px;
      padding: 0;
      box-sizing: border-box;

      /* 优惠券样式 */
      .small-coupon-item-box {
        position: relative;
        width: 372px;
        background: #ffffff;

        .coupon-item-top {
          position: relative;
          width: 100%;
          // height: 178px;
          border: 1px solid #dddddd;
          border-bottom: none;
          border-radius: 4px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          box-sizing: border-box;
        }

        .split-radius-line-box {
          position: relative;
          width: 100%;
          height: 16px;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;

          .left-box,
          .right-box {
            position: relative;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #ddd;
            margin-left: -8px;
            box-sizing: border-box;
            background: #fff;
          }

          .split-line {
            position: relative;
            width: 455px;
            height: 1px;
            border-bottom: 1px dotted #dddddd;
            box-sizing: border-box;
          }

          .right-box {
            margin-right: -8px;
          }
        }

        .coupon-item-bottom {
          position: relative;
          width: 100%;
          padding: 13px 25px 0;
          box-sizing: border-box;
          border: 1px solid #dddddd;
          border-top: none;
          border-radius: 4px;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          box-sizing: border-box;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: baseline;

          .coupon-rules-box {
            position: relative;
            flex: 1;
            height: 18px;
            box-sizing: border-box;
            overflow: hidden;

            &.expand-rule {
              height: auto;
              overflow: initial;
              // margin-bottom: 17px;
            }

            .coupon-rule-item {
              position: relative;
              width: 286px;
              // height: 40px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              // font-weight: bold;
              color: #666666;
              line-height: 18px;
              text-align: left;
              margin-bottom: 16px;

              &:last-child {
                margin-bottom: 0;
              }
            }
          }

          .icon-expand {
            position: relative;
            width: 16px;
            height: 9px;
            background-image: url(~@/assets/icon_expand_down.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            // margin-top: 5px;
            // opacity: 0.3;
            cursor: pointer;

            &.expand {
              background-image: url(~@/assets/icon_expand_up.png);
            }
          }
        }
      }

      .recharge-box {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: flex-start;

        .recharge-left-box {
          position: relative;
          flex: 1;
          height: 100%;
          padding-top: 40px;
          padding-bottom: 26px;
          overflow: hidden;
          box-sizing: border-box;

          .recharge-left-inner {
            position: relative;
            width: 100%;
            height: 100%;
            overflow-y: auto;

            &::-webkit-scrollbar {
              width: 8px;
            }
            &::-webkit-scrollbar-track {
              -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
              border-radius: 6px;
            }
            /* 滚动条滑块 */
            &::-webkit-scrollbar-thumb {
              border-radius: 6px;
              background: rgba(0, 0, 0, 0.1);
              -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
            }
            &::-webkit-scrollbar-thumb:window-inactive {
              background: rgba(255, 0, 0, 0.4);
            }
          }

          .plans-box {
            position: relative;
            width: 100%;
            // margin-top: 40px;
            padding-left: 32px;
            padding-right: 32px;
            box-sizing: border-box;

            .plan-items-box {
              position: relative;
              width: 100%;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              align-items: center;
              flex-wrap: wrap;

              .plan-item-box {
                position: relative;
                width: 140px;
                height: 124px;
                border: 1px solid #eaeaea;
                border-radius: 4px;
                box-sizing: border-box;
                margin-left: 12px;
                margin-top: 24px;
                cursor: pointer;

                &:nth-child(4n + 1) {
                  margin-left: 0;
                }

                .usetime-box {
                  position: relative;
                  width: 100%;
                  font-size: 18px;
                  line-height: 18px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #222222;
                  text-align: center;
                  margin-top: 24px;
                }

                .price-box {
                  position: relative;
                  width: 100%;
                  font-size: 22px;
                  line-height: 22px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #ec4040;
                  text-align: center;
                  margin-top: 26px;
                  display: flex;
                  display: -webkit-flex;
                  flex-direction: row;
                  align-items: baseline;
                  justify-content: center;
                  box-sizing: border-box;

                  .symbol-money {
                    position: relative;
                    font-size: 18px;
                    line-height: 18px;
                    padding-right: 4px;
                  }
                }

                .originprice-box {
                  position: relative;
                  width: 100%;
                  font-size: 16px;
                  line-height: 16px;
                  font-family: Source Han Sans CN;
                  // font-weight: bold;
                  color: #ec4040;
                  text-align: center;
                  margin-top: 10px;
                  opacity: 0.6;
                  text-decoration: line-through;
                }

                .img-selected {
                  position: absolute;
                  width: 30px;
                  height: 30px;
                  top: -1px;
                  right: -1px;
                  display: none;
                }

                &.selected {
                  position: relative;

                  background: #fff9f9;
                  border: 2px solid #ec4040;
                  box-shadow: 0px 4px 16px 0px rgba(236, 64, 64, 0.15);
                  border-radius: 4px;
                  box-sizing: border-box;

                  .img-selected {
                    display: block;
                  }

                  .usetime-box {
                    margin-top: 23px;
                  }
                }
              }
            }
          }

          .coupons-box {
            position: relative;
            width: 100%;
            margin-top: 48px;
            padding-left: 32px;
            padding-right: 32px;
            box-sizing: border-box;

            .title-text {
              .coupon-tip {
                font-size: 14px;
                line-height: 14px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #999999;
              }
            }

            .nocoupon-box {
              position: relative;
              width: 100%;
              height: 170px;
              text-align: center;

              .img-discount {
                position: relative;
                width: 72px;
                height: 60px;
                margin-top: 30px;
              }

              .nocoupon-tip {
                position: relative;
                width: 100%;

                font-size: 16px;
                line-height: 16px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #dcdcdc;
                text-align: center;
                margin-top: 16px;
              }
            }

            .hadcoupon-box {
              position: relative;
              width: 100%;
              padding-top: 24px;

              .usecoupon-tip {
                position: relative;
                width: 100%;
                font-size: 16px;
                line-height: 16px;
                font-family: Source Han Sans CN;

                color: #222222;
                margin-bottom: 16px;
                text-align: left;

                .money {
                  color: #ec4040;
                  font-weight: bold;
                }
              }

              .coupons-item-box {
                position: relative;
                // margin-top: 24px;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                flex-wrap: wrap;

                &.usecoupon {
                  margin-top: 16px;
                }

                .small-coupon-item-box {
                  position: relative;
                  width: 372px;
                  // height: 187px;
                  background: #ffffff;
                  margin-top: 20px;

                  &:first-child {
                    margin-top: 0;
                  }

                  .coupon-item-top {
                    .top-inner {
                      position: relative;
                      // height: 135px;
                      height: 91px;

                      .name-btn-box {
                        position: relative;
                        width: 100%;
                        padding-left: 25px;
                        display: flex;
                        display: -webkit-flex;
                        flex-direction: row;
                        align-items: self-start;
                        box-sizing: border-box;
                        margin-top: 33px;

                        .symbol-money-box {
                          position: relative;
                          font-size: 28px;
                          font-family: Source Han Sans CN;
                          font-weight: bold;
                          color: #221b1b;
                          margin-right: 10px;
                          // margin-top: 12px;
                        }

                        .name-cont {
                          position: relative;
                          flex: 1;
                          text-align: left;
                          font-size: 24px;
                          font-family: Source Han Sans CN;
                          font-weight: bold;
                          color: #221b1b;
                          line-height: 36px;

                          &.name-money-cont {
                            font-size: 27px;
                          }

                          .name-desc-cont {
                            position: relative;
                            width: 100%;
                            font-size: 13.5px;

                            line-height: 24px;

                            text-align: left;
                            box-sizing: border-box;
                            margin-top: 7.5px;
                          }
                        }

                        .btn-getnow {
                          position: relative;
                          width: 108px;
                          height: 36px;
                          line-height: 36px;
                          // background: linear-gradient(
                          //   0deg,
                          //   #ec4040 1%,
                          //   #ff7272 100%
                          // );
                          // border-radius: 4px;
                          box-sizing: border-box;
                          text-align: center;

                          font-size: 16px;
                          font-family: Source Han Sans CN;
                          font-weight: bold;
                          // color: #ffffff;
                          margin-right: 25px;
                        }

                        .selected-box {
                          position: relative;
                          width: 24px;
                          height: 24px;
                          border: 1px solid #dddddd;
                          border-radius: 50%;
                          box-sizing: border-box;
                          margin-right: 25px;
                          margin-top: 6px;
                          cursor: pointer;

                          &.selected {
                            background-image: url(~@/assets/icon_selected_round.png);
                            background-repeat: no-repeat;
                            background-size: 24px 24px;
                            border: none;
                          }
                        }

                        .btn-notuse {
                          position: relative;
                          width: 90px;
                          height: 48px;
                          line-height: 48px;
                          background: #222222;
                          border-radius: 24px 0px 0px 24px;

                          font-size: 16px;
                          font-family: Source Han Sans CN;
                          font-weight: bold;
                          color: #ffffff;
                          text-align: center;
                          box-sizing: border-box;
                          cursor: none;
                        }

                        .btn-used {
                          position: relative;
                          width: 90px;
                          height: 48px;
                          line-height: 48px;
                          background: #c3c3c3;
                          border-radius: 24px 0px 0px 24px;

                          font-size: 16px;
                          font-family: Source Han Sans CN;
                          font-weight: bold;
                          color: #ffffff;
                          text-align: center;
                          box-sizing: border-box;
                          cursor: none;
                        }
                      }
                    }
                  }

                  .coupon-item-bottom {
                    position: relative;
                    width: 100%;
                    padding: 13px 25px 14px;
                    box-sizing: border-box;
                    border: 1px solid #dddddd;
                    border-top: none;
                    border-radius: 4px;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                    box-sizing: border-box;
                    display: flex;
                    display: -webkit-flex;
                    flex-direction: row;
                    justify-content: space-between;

                    .description-box {
                      position: relative;
                      width: 286px;

                      .description-cont {
                        position: relative;
                        width: 286px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: bold;

                        color: #d3d3d3;
                        line-height: 18px;
                        margin-top: 15px;
                        box-sizing: border-box;
                        text-align: left;

                        &:first-child {
                          margin-top: 0;
                        }
                      }
                    }

                    .icon-expand {
                      position: relative;
                      width: 13px;
                      height: 8px;
                      background: url(~@/assets/icon_expand_down.png) no-repeat;
                      background-size: 13px 8px;
                      margin-top: 5px;
                      opacity: 0.3;
                      cursor: pointer;

                      &.expand {
                        background: url(~@/assets/icon_expand_up.png) no-repeat;
                        background-size: 13px 8px;
                      }
                    }
                  }

                  &.timeout {
                    .coupon-item-top {
                      background: #f4f4f4;

                      .top-inner {
                        .name-btn-box {
                          .symbol-money-box {
                            color: #d3d3d3;
                          }

                          .name-cont {
                            color: #d3d3d3;
                          }
                        }
                      }
                    }

                    .split-radius-line-box {
                      background: #f4f4f4;
                    }

                    .coupon-item-bottom {
                      background: #f4f4f4;

                      .coupon-rules-box {
                        .coupon-rule-item {
                          color: #d3d3d3;
                        }
                      }

                      .icon-expand {
                        opacity: 0.3;
                      }
                    }

                    .mask {
                      display: block;
                    }
                  }

                  &.selectedCoupon {
                    .coupon-item-top {
                      border-color: #ec4040;
                    }

                    .split-radius-line-box {
                      .left-box,
                      .right-box {
                        border-color: #ec4040;
                      }
                    }

                    .coupon-item-bottom {
                      border-color: #ec4040;
                    }
                  }
                }
              }
            }
          }

          .paytype-box {
            position: relative;
            width: 100%;
            margin-top: 48px;
            padding-left: 32px;
            padding-right: 32px;
            box-sizing: border-box;

            .paytype-items-box {
              position: relative;
              width: 100%;

              .paytype-item-box {
                position: relative;
                width: 100%;
                height: 60px;
                border: 1px solid #eaeaea;
                border-radius: 4px;
                margin-top: 12px;
                padding-left: 25px;
                padding-right: 25px;
                box-sizing: border-box;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                align-items: center;

                &:first-child {
                  margin-top: 24px;
                }

                .icon-check-paytype {
                  position: relative;
                  width: 20px;
                  height: 20px;
                  border: 1px solid #dddddd;
                  border-radius: 2px;
                  box-sizing: border-box;
                  margin-right: 16px;
                  cursor: pointer;

                  &.checked {
                    background: url(~@/assets/icon_selected_red2.png) no-repeat;
                    background-size: 20px 20px;
                  }
                }

                .icon-paytype {
                  position: relative;
                  width: 18px;
                  height: 18px;
                  margin-right: 20px;
                }

                .lable-paytype {
                  position: relative;
                  font-size: 18px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #222222;
                  line-height: 18px;
                }

                .balance-box {
                  position: relative;
                  padding-left: 24px;

                  font-size: 16px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #666666;
                  line-height: 16px;
                  box-sizing: border-box;

                  .cont-balance {
                    color: rgba(236, 64, 64, 1);
                  }
                }
              }
            }
          }
        }

        .recharge-right-box {
          position: relative;
          width: 420px;
          height: 100%;
          border-left: 1px solid #eaeaea;
          box-sizing: border-box;

          .icon-name-time-box {
            position: relative;
            width: 355px;
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            text-align: left;
            box-sizing: border-box;
            margin: 40px auto;

            .icon-img {
              position: relative;
              width: 80px;
              height: 80px;
              margin-right: 20px;
            }

            .name-time-box {
              position: relative;
              flex: 1;
              height: 80px;
              padding-top: 6px;
              padding-bottom: 6px;
              display: flex;
              display: -webkit-flex;
              flex-direction: column;
              justify-content: space-between;
              box-sizing: border-box;
              font-family: Source Han Sans CN;

              color: #222222;

              .name {
                position: relative;
                font-size: 22px;
                line-height: 22px;
                font-weight: bold;
              }

              .time-box {
                position: relative;
                font-size: 16px;
                line-height: 16px;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
              }
            }
          }

          .orderinfo-box {
            position: relative;
            width: 355px;
            height: 230px;
            margin: 0 auto;
            border-bottom: 1px solid #eaeaea;
            box-sizing: border-box;

            .orderinfo-item-box {
              position: relative;
              width: 100%;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              font-size: 16px;
              font-family: Source Han Sans CN;
              line-height: 16px;
              color: #222222;
              margin-top: 20px;

              &:first-child {
                margin-top: 0;
              }

              .label {
                position: relative;
                font-weight: 400;
              }

              .item-cont {
                position: relative;
                font-weight: bold;

                &.colEC4040 {
                  color: #ec4040;
                }
              }
            }
          }

          .order-pay-box {
            position: relative;
            width: 355px;
            box-sizing: border-box;
            margin: 20px auto 0;

            .balancepay-money-box {
              position: relative;
              width: 100%;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              font-family: Source Han Sans CN;
              font-weight: 800;

              .label {
                position: relative;
                font-size: 16px;
                line-height: 16px;
                color: #222222;
              }

              .pay-money {
                position: relative;
                font-size: 24px;
                line-height: 24px;
                color: #ec4040;
              }
            }

            .btn-balancepay {
              position: relative;
              width: 355px;
              height: 46px;
              line-height: 46px;
              text-align: center;

              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ffffff;
              margin-top: 32px;
            }

            .qrcodepay-box {
              position: relative;
              width: 355px;
              height: 136px;
              border: 1px solid #eaeaea;
              border-radius: 4px;
              padding: 14px;
              box-sizing: border-box;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;

              .img-qrcode {
                position: relative;
                width: 110px;
                height: 110px;
                background: #ffffff;
                border: 1px solid #eeeeee;
                box-sizing: border-box;
                margin-right: 10px;
              }

              .money-tip-box {
                position: relative;
                flex: 1;
                height: 110px;
                padding-top: 9px;
                padding-bottom: 9px;
                box-sizing: border-box;
                display: flex;
                display: -webkit-flex;
                flex-direction: column;
                justify-content: space-between;
                text-align: left;

                .money-box {
                  position: relative;
                  width: 100%;
                  display: flex;
                  display: -webkit-flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: space-between;
                  font-family: Source Han Sans CN;
                  font-weight: 800;

                  .label {
                    position: relative;
                    font-size: 16px;
                    line-height: 16px;
                    color: #222222;
                  }

                  .pay-money {
                    position: relative;
                    font-size: 24px;
                    line-height: 24px;
                    color: #ec4040;
                  }
                }

                .tip-box {
                  position: relative;
                  font-size: 14px;
                  line-height: 14px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #222222;
                }
              }
            }
          }
        }
      }
    }

    // .el-form-item {
    //   margin-bottom: 30px;
    // }
    .el-dialog__footer {
      position: relative;
      width: 100%;
      padding: 40px;
      box-sizing: border-box;
      text-align: center;

      .btn-submit {
        position: relative;
        width: 224px;
        height: 46px;
        line-height: 46px;
        text-align: center;

        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
.coupon-tooltip-box {
  &.el-tooltip__popper {
    padding: 18px;

    .coupon-tooltip {
      position: relative;
      font-size: 14px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      color: #ffffff;
      line-height: 24px;

      .tip-item {
        position: relative;
        margin-top: 20px;

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
.right-inner {
  position: relative;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ec4040;
  line-height: 16px;

  .icon-remind {
    position: relative;
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
</style>
